<template>
  <app-timeline-item variant="secondary">
    <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
      <h5>
        {{ especialidad. abrev_espe }} | {{ especialidad.nombre }}
      </h5>
      <b-badge
        pill
        variant="light-primary"
        style="cursor: pointer;"
        @click="loadcuatri(especialidad.plan_id); isvisible =! isvisible"
      >
        <b-spinner
          v-show="isBusy"
          small
          type="grow"
        />
        {{ (isBusy) ? 'Trabajando...': '' }}
        {{ (!isvisible) ? 'Ver' : 'Ocultar' }} cuatrimestres
      </b-badge>
    </div>
    <!-- list de cuatris -->
    <cuatrimestre
      v-for="cua in cuatrimestres"
      v-show="isvisible"
      :key="cua.agenda_id"
      :cuatrimestre="cua"
    />
  </app-timeline-item>

</template>
<script>
import { ref } from '@vue/composition-api'
import {
  BBadge,
  BSpinner,
} from 'bootstrap-vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
// import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import cuatrimestre from './Cuatrimestre.vue'
import { getcuatrimestres } from '../../useAlumno'

export default {
  components: {
    AppTimelineItem,
    BBadge,
    cuatrimestre,
    BSpinner,
  },
  props: {
    especialidad: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  setup() {
    const toast = useToast()
    const cuatrimestres = ref({})
    const isvisible = ref(false)
    const isBusy = ref(false)

    const loadcuatri = iden => {
      isBusy.value = true
      getcuatrimestres(iden).then(response => {
        cuatrimestres.value = response
        isBusy.value = false
        // toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Buscando..',
        //     text: response.message,
        //     icon: 'CheckIcon',
        //     variant: 'success',
        //   },
        // })
      }, error => {
        isBusy.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atencion [Sin cuatrimestres]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
    }

    return {
      // data
      cuatrimestres,
      // flags
      isBusy,
      isvisible,
      // functions
      loadcuatri,

    }
  },
}
</script>
<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  li {
    list-style: none;
  }
</style>
